import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import OPTooltip from "components/material/tooltip"
import { get } from "lodash"

export function SecondaryIcon({ item, handleAction }) {
  if (!item?.secondaryAction) { return null }
  const content = <IconButton
    data-test-class="secondary-icon"
    disabled={item.secondaryDisabled}
    onClick={(event) => {
      event.stopPropagation()
      handleAction(item.secondaryAction, item.noDispatch, item.secondaryActionOnly, item)
    }}
    tabIndex={-1}
    size="large"
  >
    {item.secondaryIcon}
  </IconButton>

  if (!item.secondaryTooltip) {
    return content
  }

  return <OPTooltip data-test-class="secondary-icon-tooltip" title={get(item, "secondaryTooltip", "")}>
    <div>
    {content}
    </div>
  </OPTooltip>
}

SecondaryIcon.propTypes = {
  item: PropTypes.object.isRequired,
  handleAction: PropTypes.func.isRequired,
}
